var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"justify-center align-center fill-height"},[_c('div',{staticClass:"display-4"},[_vm._v("404")])])}
var staticRenderFns = []

export { render, staticRenderFns }